import React from 'react'
import PropTypes from 'prop-types'
import {
  StyledContainer,
  Description,
  DateTitle,
  DateWrapper,
  Error,
  ErrorText,
  Title,
  TitleWrapper,
  StyledWarningIcon,
} from './component.styles'
import { CalendarInput } from 'secondstep-components'

const StartDateInput = ({
  className,
  title,
  description,
  date,
  inputLabel,
  handleChange,
  name,
  error,
  touched,
}) => {
  return (
    <StyledContainer className={className}>
      <TitleWrapper>
        {title && <Title>{title}</Title>}
        {description && <Description>{description}</Description>}
      </TitleWrapper>
      <DateWrapper>
        {(inputLabel || title) && (
          <DateTitle>{inputLabel || `${title} Date`}</DateTitle>
        )}
        <CalendarInput
          date={date}
          handleChange={handleChange}
          hasError={!!error && !!touched}
          name={name}
          showNeighboringMonth={false}
        />
        {error && touched && (
          <Error>
            <StyledWarningIcon />
            <ErrorText>{error}</ErrorText>
          </Error>
        )}
      </DateWrapper>
    </StyledContainer>
  )
}

StartDateInput.propTypes = {
  className: PropTypes.string,
  date: PropTypes.object,
  description: PropTypes.string,
  error: PropTypes.string,
  errorHeader: PropTypes.string,
  handleChange: PropTypes.func,
  inputLabel: PropTypes.string,
  isTouched: PropTypes.bool,
  name: PropTypes.string,
  setFieldValue: PropTypes.func,
  title: PropTypes.string,
  touched: PropTypes.bool,
}

export default StartDateInput
